import { Icon } from "@components/icon";
import { LinkWithConfirm } from "@components/link_with_confirm/link_with_confirm";
import * as types from "@root/types";
import { isEmpty } from "@services/helpers";
import { isNil, truncate } from "@services/typed_helpers";
import cx from "classnames";
import React, { type FC } from "react";

interface ContentBlockListProps {
  contentBlocks: types.ContentBlockModel[] | undefined;
}
const ContentBlockRow: FC<{ contentBlock: types.ContentBlockModel }> = ({
  contentBlock,
}) => {
  const deleteLink = (
    <LinkWithConfirm
      className="delete_link"
      confirmMessage="Are you sure you want to delete this content block?"
      href={`/admin/content_block/${contentBlock.id}/delete`}
      title="Delete"
    >
      <Icon name="bin2" />
    </LinkWithConfirm>
  );

  const editLink = (
    <a
      href={`/admin/content_block/${contentBlock.id}`}
      aria-label="edit"
      title="Edit"
    >
      <Icon name="pencil" />
    </a>
  );

  return (
    <tr>
      <td className="page">{contentBlock.page}</td>
      <td className="section">{contentBlock.section}</td>
      <td className="body">{truncate(contentBlock.body)}</td>
      <td className="ctrls">
        <div className="actions">
          {editLink}
          {deleteLink}
        </div>
      </td>
    </tr>
  );
};

const ContentBlocksList: FC<ContentBlockListProps> = ({ contentBlocks }) => {
  return (
    <table className={cx("content_blocks", "striped", "admin-table")}>
      <thead>
        <tr>
          <th scope="col">Page</th>
          <th scope="col">Section</th>
          <th scope="col">Body (truncated)</th>
          <th className="ctrls" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        {isNil(contentBlocks) || isEmpty(contentBlocks) ? (
          <tr>
            <td colSpan={4}>You've got no content blocks!</td>
          </tr>
        ) : (
          contentBlocks.map((contentBlock) => (
            <ContentBlockRow
              contentBlock={contentBlock}
              key={contentBlock.id}
            />
          ))
        )}
      </tbody>
    </table>
  );
};

export { ContentBlocksList };
